import { render } from "./SeminarDetails.vue?vue&type=template&id=8f9c022a&ts=true"
import script from "./SeminarDetails.vue?vue&type=script&lang=ts"
export * from "./SeminarDetails.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__